cv.PublicTeamsRowView = Marionette.LayoutView.extend({
  tagName: 'a',
  className: 'team result',
  template: cv.Templates['public/teams/teams_row'],

  events : {
  },

  templateHelpers: function(){
    return {
      name : this.model.get('name'),
      meta : cv.formatMoney({
        amount : this.model.get('funds_raised'),
        show_sign : true,
        currency_code : this.model.get('campaign.currency_code'),
        decimal_places : 0
      }) + ' Raised',
      photo_path : cv.photo({
        photo_path : this.model.get('photo_path'),
        transforms : {
          fit : 'crop'
        },
        url_only : true
      })
    };
  },

  initialize: function(options){
    console.log('PublicTeamsRowView initialized');
  },

  onShow: function(){
    imgix.fluid(this.$el.get(0), {
      rootNode: this.$el.get(0),
      updateOnResizeDown: false,
      autoInsertCSSBestPractices: true
    });

    this.$el.attr('href', '/team/' + this.model.get('stub'))
  }
});
